import { jsx as _jsx } from "react/jsx-runtime";
import { Trolley, Check, Box, Snail, Xmark, ShoppingCart, Wrench, Car } from '@gravity-ui/icons';
export const getStatusIcon = (status) => {
    switch (status) {
        case 'Котгрузке':
            return (_jsx(Trolley, { style: {
                    color: 'rgba(100, 122, 141, 1)',
                    verticalAlign: 'sub',
                    marginRight: '4px'
                } }));
        case 'Выдан':
            return (_jsx(Check, { style: {
                    color: 'rgba(48, 170, 110, 1)',
                    verticalAlign: 'sub',
                    marginRight: '4px'
                } }));
        case 'service.created':
            return (_jsx(Box, { style: {
                    color: 'rgba(100, 122, 141, 1)',
                    verticalAlign: 'sub',
                    marginRight: '4px'
                } }));
        case 'Втранзите':
            return (_jsx(Snail, { style: {
                    color: 'rgba(100, 122, 141, 1)',
                    verticalAlign: 'sub',
                    marginRight: '4px'
                } }));
        case 'Отказ':
            return (_jsx(Xmark, { style: {
                    color: 'rgba(233, 3, 58, 1)',
                    verticalAlign: 'sub',
                    marginRight: '4px'
                } }));
        case 'Взаказе':
            return (_jsx(ShoppingCart, { style: {
                    color: 'rgba(100, 122, 141, 1)',
                    verticalAlign: 'sub',
                    marginRight: '4px'
                } }));
        case 'Вработе':
            return (_jsx(Wrench, { style: {
                    color: 'rgba(100, 122, 141, 1)',
                    verticalAlign: 'sub',
                    marginRight: '4px'
                } }));
        case 'Впути':
            return (_jsx(Car, { style: {
                    color: 'rgba(100, 122, 141, 1)',
                    verticalAlign: 'sub',
                    marginRight: '4px'
                } }));
        default:
            return null;
    }
};
